import { useState } from "react";
import { Heart, MessageCircle } from "lucide-react";
import SupportDialog from "@/components/SupportDialog";

export default function StickySupport({ settings }) {
  const [open, setOpen] = useState(false);
  const wa = (settings?.whatsapp || "+919555885651").replace(/[^\d]/g, "");
  return (
    <>
      <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3 items-end">
        <a
          href={`https://wa.me/${wa}?text=${encodeURIComponent(
            "Hello Dr. Abhishek Garg, I'd like to support your DMC campaign."
          )}`}
          target="_blank"
          rel="noreferrer"
          data-testid="whatsapp-floating-btn"
          aria-label="WhatsApp"
          className="w-12 h-12 grid place-items-center bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform"
        >
          <MessageCircle size={22} />
        </a>
        <button
          onClick={() => setOpen(true)}
          data-testid="sticky-support-now-button"
          className="bg-[hsl(var(--accent))] text-white font-semibold uppercase text-xs tracking-widest px-5 py-3 shadow-xl hover:bg-[hsl(var(--accent-hover))] inline-flex items-center gap-2"
        >
          <Heart size={14} /> Support Now
        </button>
      </div>
      <SupportDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
